import categoryDashboardPageLoad from "~/store/graphql/queries/categoryDashboardPageLoad.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const loadCategoryDashboard = async function (
  { commit },
  { params, req, res }
) {
  commit("START_LOADING");

  const data = await runGraphQLQuery(
    categoryDashboardPageLoad,
    params,
    this.$axios,
    req,
    res
  );

  commit("SET_CATEGORY_DASHBOARD", data);
  commit("END_LOADING");

  return Promise.resolve(data);
};

export default loadCategoryDashboard;
